import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { api } from "../../../middleware/api";
import { UtilityFunctions } from '../../../utils/UtilityFunctions';
import UpdateProfileEmployer from '../Settings/UpdateProfileEmployer'
import UpdateProfileEmployee from '../Settings/UpdateProfileEmployee'
import UpdatePassword from '../Settings/UpdatePassword'
import TransactionHistory from '../Settings/TransactionHistory';
import UpdateMyExperience from "./UpdateMyExperience"
import Subscription from '../Settings/Subscription'
import SubscriptionInNav from '../Settings/SubscriptionInNav'
import { Link } from 'react-router-dom';
import Terms from '../Settings/Terms'
import Privacy from '../Settings/Privacy'
import FAQ from './FAQ'
import About from "./About"
import DefaultPage from '../Settings/DefaultPage'
import { cookieService, userService } from "../../../_services";
import { STRING_CONSTANTS } from "../../../utils/constants/stringConstants";
import Logout from "../../../components/logout";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "../../../store";
import { bindActionCreators } from "redux";
import UpgradePlanCheck from "../Home/upgradePlanCheck";
import { END_POINTS } from "../../../utils/constants/endPoints";
import SuccessToast from "../../../components/successToast";
import DeleteAccount from "../../../components/deleteAccount";
import QRCodeModal from "../../../components/qRCode"
import { Data } from "../../../_services/collections";
import OnboardingTutorial from "./OnboardingTutorial";
import RejectionReasons from "./RejectionReasons"
import GuardianEmail from "../../../components/guardianEmail"
import ShareApp from "../../../components/shareApp"
import moment from "moment";
import CancelSubscription from '../Settings/CancelSubscription';
import SocketClient from "../../../library/SocketClient";

const Modules = (props: any) => {
    const [show, setShow] = useState(false);
    const [activeTab, setActiveTab] = useState('defaultPage');
    const state = useSelector((state: State) => state);
    const [showDeleteAccPopup, setShowDeleteAccPopup] = useState(false);
    const [showQRCode, setShowQRCode] = useState(false)
    const dispatch = useDispatch();
    const { setShowSideBarOnMobileView } = bindActionCreators(actionCreators, dispatch);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [mailAddress, setMailAddress] = useState();
    const [showShareAppModal, setShowShareAppModal] = useState(false);
    const [isSubPurchased, setIsSubPurchased] = useState(false);
    const [cancelSub, setCancelSub] = useState(false);
    const [unreadMsgCount, setUnreadMsgCount] = useState(0);
    const userData = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user)
    const urlParams = new URLSearchParams(window.location.search);
    const user = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);
    const myParam = urlParams.get('activeTab');
    const resend = () => {
        let isEmailVerified: boolean;
        api.get(END_POINTS.user, {})
            .then(res => isEmailVerified = (res.user.isEmailVerified))
            .then(() => {
                if (isEmailVerified === false) {
                    userService
                        .resendMail()
                        .then(() => { })
                        .catch(
                        // e => console.log(e)
                    )
                    SuccessToast(STRING_CONSTANTS.SUCCESS_MESSAGES.SUCCESS_HEADER, STRING_CONSTANTS.SUCCESS_MESSAGES.RESEND_VERIFICATION_EMAIL);
                }
                else {
                    setTimeout(() => {
                        props.history.push(STRING_CONSTANTS.navigationString.index)
                    }, 2000)
                    SuccessToast(STRING_CONSTANTS.SUCCESS_MESSAGES.SUCCESS_HEADER, STRING_CONSTANTS.SUCCESS_MESSAGES.EMAIL_VERIFIED)
                }
            })
            .catch(
            // (e) => console.log(e)
        )
        // console.log(isEmailVerified)
    };
    useEffect(() => {
        if (myParam) {
            activeTabSet(myParam);
        } else {
            props?.location?.state?.tab && activeTabSet(props?.location?.state?.tab)
        }
    }, [props?.location?.state?.tab, myParam])

    useEffect(() => {
        props?.location?.state?.tab && activeTabSet(props.location.state.tab)
    }, [])

    useEffect(() => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let menu_type = params.get('type');
        if (menu_type == "subscription") {
            activeTabSet('subscriptionInNav')
        }
    }, [])

    useEffect(() => {
        api.get(`chat/rooms/?limit=1`, null).then((res) => {
            setUnreadMsgCount(res?.results?.unreadChatsCount);
        }).catch((err) => { });
    }, [state?.chatReducer?.current_user_latest_message])


    const getUserSubscription = () => {
        api.get('subscription/', {})
            .then(res => {
                if (res?.active) {
                    // alert(res?.subscriptionCanceled)
                    setIsSubPurchased(!res?.subscriptionCanceled)
                }
            }).catch((err) => {
                console.log(err)
            })
    }
    useEffect(() => {
        getUserSubscription();
    }, [cancelSub]);

    let activeTabSet = tabName => {
        setShowSideBarOnMobileView(false);
        setActiveTab(tabName);
    }

    const contactAdmin = () => {
        userService.contactAdmin()
            .then(response => {
                return response?.email
            })
            .then((data) => {
                window.open(`mailto:${data.toString()}?subject=Customer Service`)
            })
            .catch((e) => {
            })
    }
    const openedTab = (active) => {
        if (active === "defaultPage") {
            return <DefaultPage />
        }
        if (active === "updateProfile") {
            if (userData?.user?.type === STRING_CONSTANTS.userType.employee) {
                return <UpdateProfileEmployee />
            }
            else if (userData?.user?.type === STRING_CONSTANTS.userType.employer) {
                return <UpdateProfileEmployer />
            }
        }
        else if (active === "updatePassword") {
            return <UpdatePassword />
        }
        else if (active === "subscription") {
            return <Subscription />
        } else if (active === "subscriptionInNav") {
            return <SubscriptionInNav />
        }
        else if (active === "updateMyExperience") {
            return <UpdateMyExperience props={props} />
        }
        else if (active === "terms") {
            return <Terms />
        }
        else if (active === "privacy") {
            return <Privacy />
        }
        else if (active === "faq") {
            return <FAQ />
        }
        else if (active === "rejectionReasons") {
            return <RejectionReasons />
        }
        else if (active === "about") {
            return <About />
        }
        else if (active === "transactionHistory") {
            return <TransactionHistory />
        } else if (active === "cancelSubscription") {
            return <CancelSubscription activeTabSet={(val) => activeTabSet(val)} setCancelSub={() => setCancelSub(!cancelSub)
            } />
        }
    }

    const shareProfileSection = () => {
        if (userData?.user?.type === STRING_CONSTANTS.userType.employee) {
            // if (userData?.user?.referralUsedCount < 2) {
            //     return <li className="d-flex align-items-end justify-content-between">
            //         <div className="mymedia">
            //             <h3>Unlock an advanced profile</h3>
            //             <p>Users successfully registered with my link <span>{userData?.user?.referralUsedCount}/2</span></p>
            //         </div>
            //         <div className="right-side-desi" onClick={() => setShowShareAppModal(true)}>
            //             <img src={UtilityFunctions.getImageURL() + "Share.svg"} alt="" />
            //         </div>
            //     </li>
            // }
            if (userData?.user?.referralUsedCount >= 0 && !userData?.isAdvanceProfileCompleted) {
                return <li onClick={() => props.history.push(STRING_CONSTANTS.navigationString.advanced_profile)} className="d-flex align-items-center justify-content-between" style={{ cursor: "pointer" }}>
                    <div className="mymedia">
                        <h3>Advanced Profile Unlocked</h3>
                        <p>Complete you advance profile</p>
                    </div>
                    <div className="right-side-desi"
                    // onClick={() => props.history.push(STRING_CONSTANTS.navigationString.advanced_profile)}
                    >
                        <img src={UtilityFunctions.getImageURL() + "error-icon-red-fill.svg"} className="p-0" alt="" />
                    </div>
                </li>
            }
        }
    }

    return (<>
        <section className="main-dashboard-wrap">
            {/* <SocketClient/> */}
            <div id="wrapper" style={{ height: "100vh" }}>
                <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${state.common.showSidebarOnMobileView ? "active" : ""}`} id="accordionSidebar">
                    <div>
                        <Link style={{ pointerEvents: "none" }} className="sidebar-brand d-flex align-items-center justify-content-center" to="/">
                            <img src={UtilityFunctions.getImageURL() + "db-logo.svg"} />
                        </Link>
                        {!user?.user?.isAccountsSignup && <li className="nav-item">
                            <Link className="nav-link" to="/dashboard/home">
                                <img src={UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"} alt="" />
                                <img src={UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"} alt="" />
                            </Link>
                        </li>}
                        {user?.user?.isAccountsSignup && <li className="nav-item">
                            <Link className="nav-link" to="/ar">
                                <img src={UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"} alt="" />
                                <img src={UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"} alt="" />
                            </Link>
                        </li>}

                        {!user?.user?.isAccountsSignup && <li className="nav-item notification-nav">
                            <Link className="nav-link" to="/dashboard/chat/">
                                <div className="svg-box">
                                    <img src={UtilityFunctions.getImageURL() + "chat-icon.svg"} alt="" />
                                    <img src={UtilityFunctions.getImageURL() + "chat-icon-fill-green.svg"} alt="" />
                                    {unreadMsgCount ? <span >{unreadMsgCount > 9 ? "9+" : unreadMsgCount}</span> : ""}
                                </div>
                            </Link>
                        </li>}

                        {false && user?.user?.type === STRING_CONSTANTS.userType.employer && <li className="nav-item">
                            <Link className="nav-link" to="/dashboard/modules">
                                <img src={UtilityFunctions.getImageURL() + "employeesLandingPage/exploreFifth.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="" />
                                <img src={UtilityFunctions.getImageURL() + "employeesLandingPage/exploreFifth.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="" />
                            </Link>
                        </li>}

                    </div>
                    <div>
                        <li className="nav-item">
                            <UpgradePlanCheck />
                        </li>
                    </div>
                    <div>
                        <li className="nav-item notification-nav">
                            <Link className="nav-link" to="/dashboard/notifications">
                                <div className="svg-box">
                                    <img src={UtilityFunctions.getImageURL() + "bell-icon-blank-white.svg"} alt="" />
                                    <img src={UtilityFunctions.getImageURL() + "bell-icon-fill-green.svg"} alt="" />
                                    {/* <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 0.75C6.34011 0.75 2.56251 4.5276 2.56251 9.1875V13.6901L0.754443 18.2146C0.639024 18.5034 0.674363 18.8307 0.848778 19.0882C1.02319 19.3457 1.31397 19.5 1.625 19.5H7.25C7.25 21.5782 8.92183 23.25 11 23.25C13.0782 23.25 14.75 21.5782 14.75 19.5H20.375C20.686 19.5 20.9768 19.3457 21.1512 19.0882C21.3256 18.8307 21.361 18.5034 21.2456 18.2146L19.4375 13.6901V9.1875C19.4375 4.5276 15.6599 0.75 11 0.75ZM12.875 19.5C12.875 20.5426 12.0426 21.375 11 21.375C9.95736 21.375 9.125 20.5426 9.125 19.5H12.875ZM4.43751 9.1875C4.43751 5.56313 7.37564 2.625 11 2.625C14.6244 2.625 17.5625 5.56313 17.5625 9.1875V13.8705C17.5625 13.9897 17.5852 14.1077 17.6294 14.2184L18.9908 17.625H3.00923L4.37057 14.2184C4.41479 14.1077 4.43751 13.9897 4.43751 13.8705V9.1875Z" fill="white" />
                                    </svg>*/}
                                    {/* <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.56251 9.1875C2.56251 4.5276 6.34011 0.75 11 0.75C15.6599 0.75 19.4375 4.5276 19.4375 9.1875V12.757L21.2454 17.2768C21.361 17.5657 21.3257 17.893 21.1513 18.1506C20.9769 18.4082 20.6861 18.5625 20.375 18.5625H1.625C1.31392 18.5625 1.02309 18.4082 0.848691 18.1506C0.674288 17.893 0.639024 17.5657 0.754558 17.2768L2.56251 12.757V9.1875ZM7.36709 20.4375C7.78113 22.0588 9.2458 23.25 11 23.25C12.7542 23.25 14.2189 22.0588 14.6329 20.4375H7.36709Z" fill="#06EFC5" />
                                    </svg>  */}
                                    {state?.unreadNotificationCount?.unreadNotificationCount ? <span>{state?.unreadNotificationCount?.unreadNotificationCount > 9 ? "9+" : state?.unreadNotificationCount?.unreadNotificationCount}</span> : ""}
                                </div>
                            </Link>
                        </li>
                        <li className="nav-item" style={{ pointerEvents: "none" }}>
                            <Link className="nav-link active" to="#offcanvasExample">
                                <img src={UtilityFunctions.getImageURL() + "settings-icon-blank-white.svg"} alt="" />
                                <img src={UtilityFunctions.getImageURL() + "settings-icon-fill-green.svg"} alt="" />
                                {/* <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.0001 10.1783C12.3373 10.1783 10.1787 12.3369 10.1787 14.9997C10.1787 17.6625 12.3373 19.8211 15.0001 19.8211C16.4453 19.8211 17.742 19.1853 18.6256 18.1782C19.3702 17.3296 19.8216 16.2174 19.8216 14.9997C19.8216 14.5069 19.7476 14.0314 19.6103 13.5836C19.0053 11.6119 17.1701 10.1783 15.0001 10.1783ZM11.7859 14.9997C11.7859 13.2245 13.2249 11.7854 15.0001 11.7854C16.7753 11.7854 18.2144 13.2245 18.2144 14.9997C18.2144 16.7749 16.7753 18.214 15.0001 18.214C13.2249 18.214 11.7859 16.7749 11.7859 14.9997ZM23.2601 23.994L21.4092 23.1815C20.8797 22.9494 20.2577 22.9834 19.7573 23.2731C19.2569 23.5629 18.9377 24.0739 18.8741 24.6495L18.6515 26.6627C18.6056 27.0779 18.3044 27.4194 17.8989 27.516C15.9926 27.9705 14.0064 27.9705 12.1001 27.516C11.6945 27.4194 11.3933 27.0779 11.3474 26.6627L11.1252 24.6525C11.06 24.078 10.7264 23.5685 10.2264 23.2798C9.72639 22.991 9.11925 22.9571 8.59148 23.188L6.74018 24.0006C6.35672 24.169 5.909 24.0766 5.62306 23.7702C4.29094 22.3428 3.29932 20.6312 2.72287 18.7643C2.59871 18.3622 2.74217 17.9254 3.08039 17.6758L4.71677 16.4679C5.18287 16.1248 5.45814 15.5799 5.45814 15.0004C5.45814 14.4209 5.18287 13.876 4.71616 13.5324L3.08081 12.3266C2.74208 12.0768 2.59849 11.6395 2.72309 11.237C3.30054 9.37181 4.29267 7.66212 5.62483 6.23659C5.91104 5.93031 6.35898 5.83831 6.74238 6.00706L8.58545 6.81827C9.11578 7.05146 9.72546 7.01623 10.2282 6.72196C10.7287 6.43106 11.062 5.91958 11.1263 5.34387L11.3501 3.33198C11.3969 2.91183 11.705 2.56791 12.1169 2.47613C13.0609 2.26577 14.0241 2.15399 15.0141 2.14258C15.9802 2.15373 16.9424 2.26556 17.8853 2.47626C18.2969 2.56823 18.6047 2.91205 18.6515 3.33198L18.8755 5.34541C18.9769 6.26988 19.7559 6.97007 20.6846 6.97105C20.9342 6.97144 21.1812 6.91935 21.4119 6.8171L23.2553 6.00574C23.6387 5.83699 24.0866 5.92899 24.3728 6.23527C25.705 7.6608 26.6971 9.37049 27.2746 11.2357C27.3991 11.6379 27.2558 12.075 26.9175 12.3248L25.2835 13.5315C24.8174 13.8746 24.5359 14.4195 24.5359 14.999C24.5359 15.5785 24.8174 16.1234 25.2845 16.4673L26.9199 17.6744C27.2583 17.9242 27.4017 18.3614 27.2772 18.7637C26.7 20.6285 25.7084 22.3381 24.377 23.7639C24.0911 24.0701 23.6435 24.1623 23.2601 23.994ZM17.4248 23.7817C17.6768 23.0016 18.2025 22.3163 18.9519 21.8823C19.8967 21.3353 21.0576 21.2725 22.0545 21.7097L23.4945 22.3418C24.4191 21.2716 25.1351 20.0368 25.6053 18.7016L24.3317 17.7616L24.3308 17.7608C23.4623 17.121 22.9287 16.1007 22.9287 14.999C22.9287 13.8981 23.4616 12.8777 24.3293 12.2383L24.3307 12.2373L25.6027 11.2979C25.1324 9.96265 24.416 8.7279 23.491 7.65791L22.0632 8.28635L22.0607 8.28745C21.6263 8.47962 21.1578 8.57882 20.6829 8.57819C18.9339 8.57594 17.4694 7.25785 17.2781 5.5225L17.2779 5.52063L17.1039 3.95648C16.4147 3.82817 15.7155 3.759 15.0141 3.74984C14.2918 3.7592 13.5881 3.82859 12.8977 3.95674L12.7235 5.52235C12.6028 6.60257 11.978 7.56296 11.0379 8.11022C10.0923 8.6628 8.9407 8.73012 7.93802 8.28924L6.50663 7.65923C5.58173 8.72913 4.86541 9.96376 4.3951 11.2989L5.66994 12.2389C6.5478 12.8856 7.06529 13.9108 7.06529 15.0004C7.06529 16.0896 6.54809 17.1149 5.67054 17.7614L4.39472 18.7031C4.86445 20.0401 5.58067 21.2766 6.50591 22.3483L7.94738 21.7155C8.94383 21.2796 10.0884 21.3441 11.0302 21.888C11.9723 22.4321 12.5994 23.3911 12.7221 24.4711L12.7227 24.4759L12.8961 26.0448C14.2851 26.318 15.7139 26.318 17.1029 26.0448L17.2766 24.473C17.3027 24.2372 17.3525 24.0056 17.4248 23.7817Z" fill="white" />
                                </svg> */}

                            </Link>
                        </li>
                        <li className='profile-pic'>
                            <img
                                src=
                                {userData?.user?.type === STRING_CONSTANTS.userType.employer ? (userData?.logo || UtilityFunctions.getImageURL() + "profile-pic.png") : (userData?.profilePhoto || UtilityFunctions.getImageURL() + "default-employee-profile-pic-round.svg")}
                            />
                        </li>
                    </div>
                </ul>
                <div className={`offcanvas offcanvas-start mobile-outer-bar ${state.common.showSidebarOnMobileView ? 'active ' : ''}`} id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                    <div className={userData?.user?.type === STRING_CONSTANTS.userType.employer ? '' : "navbar-setting-top-bg"}>
                        <div className="submenu-title d-flex align-items-center pe-4">
                            <h2 className="setting-title mb-0">MPLOI Modules</h2>
                        </div>
                    </div>

                    <div className="menu-label blue">MPLOI AI</div>
                    <ul className="sub-menu-new nav" id="v-pills-tab" role="tablist" aria-orientation="vertical" style={{ flexDirection: "column" }}>
                        <li onClick={() => window.open('https://simulation.mploi.com/hr')}>
                            <a id="panel1-tab" data-bs-toggle="pill" aria-selected="true">
                                <div>
                                    <span className="">
                                        <img src={UtilityFunctions.getImageURL() + "employersLandingPage/assist.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="MPLOI HR Assist" />
                                    </span>
                                    HR Assist
                                </div>
                            </a>
                        </li>
                        <li onClick={() => window.open('https://simulation.mploi.com/legal')}>
                            <a id="panel1-tab" data-bs-toggle="pill" aria-selected="true">
                                <div>
                                    <span className="">
                                        <img src={UtilityFunctions.getImageURL() + "employersLandingPage/hammer.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="MPLOI Legal Assist" />
                                    </span>
                                    Legal Assist
                                </div>
                            </a>
                        </li>
                        <li onClick={() => window.location = '/ar'}>
                            <a id="panel1-tab" data-bs-toggle="pill" aria-selected="true">
                                <div>
                                    <span className="">
                                        <img src={UtilityFunctions.getImageURL() + "employeesLandingPage/exploreFirst.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="MPLOI Interview Simulator" />
                                    </span>
                                    Accounts Receivable
                                </div>
                            </a>
                        </li>

                        <div className="menu-label blue">MPLOI Marketing</div>

                        <li onClick={() => window.open('https://simulation.mploi.com/marketing')}>
                            <a id="panel1-tab" data-bs-toggle="pill" aria-selected="true">
                                <div>
                                    <span className="">
                                        <img src={UtilityFunctions.getImageURL() + "employersLandingPage/exporeFourth.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="MPLOI Legal Assist" />
                                    </span>
                                    Legal Assist
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <span className={`mobile-menu othersetups ${state.common.showSidebarOnMobileView ? "active" : ""}`} onClick={() => setShowSideBarOnMobileView(!state.common.showSidebarOnMobileView)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                        <div className="tab-content" id="v-pills-tabContent">
                            {openedTab(activeTab)}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
    );
}

export default withRouter(Modules)